import { useFeatureFlag } from "../../../launch-darkly/useLaunchDarkly";
import { useAICalendarEventCards } from "./useAICalendarEventCards";
import { useGatewayCalendarEvents } from "./useGatewayCalendarEvents";

export function useCalendarEventCards(
  weekDate: string,
  calendarIds: string[],
  ownCalendarIds: string[],
) {
  const [isUsingGateway, loading, initialized] = useFeatureFlag("GatewayCalendar");

  // We want these to be empty when we are loading or not initialized, so that we skip queries
  // during that time.
  const date = loading || !initialized ? "" : weekDate;
  // Giving no date value will cause the queries to be skipping when we don't pass the feature flag.
  const gatewayEvents = useGatewayCalendarEvents(
    isUsingGateway ? date : "",
    calendarIds,
    ownCalendarIds,
  );
  // Giving no date value will cause the queries to be skipping when we don't pass the feature flag.
  const webserverEvents = useAICalendarEventCards(
    !isUsingGateway ? date : "",
    calendarIds,
    ownCalendarIds,
  );

  return isUsingGateway ? gatewayEvents : webserverEvents;
}
